import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Grid, Paper, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import apiService from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

const AddMarketLinkage = () => {
    const navigate = useNavigate();
    const [seasonList, setSeasonList] = useState([]);
    const [seedClassList, setSeedClassList] = useState([]); // State for seed classes
    const [seedList, setSeedList] = useState([]);
    const [varietyList, setVarietyList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const [cropPlanDetails, setCropPlanDetails] = useState([]);
    const [formData, setFormData] = useState({
        seedSowingDate: "",
        cultivatedArea: "",
        cropCuttingDate: "",
        yield5x5: "",
        productionAmount: "",
    });
    const location = useLocation();
    const { cropPlanId,data } = location.state || {};

    function mergeDataWithSeedClassId(dataArray, template, seedClassArray) {
    // Create a lookup map for seedClassId by className
    const seedClassMap = seedClassArray.reduce((map, item) => {
        map[item.className] = item.seedClassId;
        return map;
    }, {});

    return dataArray.map(item => {
        // Copy the template for each item
        const newItem = { ...template };

        // Add cropPlanId and find seedClassId using the map
        newItem.cropPlanId = item.cropPlanId;
        newItem.seedClass = item.className;
        newItem.seedClassId = seedClassMap[item.className] || null; // Default to null if not found

        // Return the merged object
        return newItem;
    });
}


    

    
console.log(JSON.stringify(data));
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (cropPlanId) {
                    const response = await apiService.get(`/crop-plan-master/get-cropplan-details/${cropPlanId}`);
                    if (response.data.status) {
                        setCropPlanDetails(response.data.body.cropPlans);
                    } else {
                        console.error('Error fetching crop plan details');
                    }
                }

                // Fetching seed classes from the new API
                const seedClassRes = await apiService.get('/seed-classes/get-all');
                console.log("seedClassRes", seedClassRes);
                
                setSeedClassList(seedClassRes.data);

                const [casteRes, seasonRes, seedRes, varietyRes] = await Promise.all([
                    apiService.get('/castes/get-all'),
                    apiService.get('/seasons/get-all'),
                    apiService.get('/seeds/get-all'),
                    apiService.get('/seed-varieties/get-all'),
                ]);

                setCasteList(casteRes.data);
                setSeasonList(seasonRes.data);
                setSeedList(seedRes.data.map(seed => ({ ...seed, seedName: seed.seedName.trim() })));
                setVarietyList(varietyRes.data.map(variety => ({ ...variety, varietyName: variety.varietyName.trim() })));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [cropPlanId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const handleSubmit = async () => {
        try {
            const result = mergeDataWithSeedClassId(data, formData, seedClassList);

            const payload = {
                cropPlanMasterId: cropPlanId,
                cropProductions: result,
            };

            const response = await apiService.post('/crop-master/create-production', payload);
            if (response.data.status) {
                navigate(-1);
                console.log('Crop production created successfully:', response.data);
            } else {
                console.error('Error creating crop production');
            }
        } catch (error) {
            console.error('Error submitting form data:', error);
        }

    };

    return (
        <Paper elevation={4} sx={{ padding: 4, borderRadius: 0, height: "92vh", overflowY: "auto" }}>
            <Typography variant="h3" gutterBottom align="center" sx={{ color: "#1976d2", fontWeight: "bold" }}>
                Add Production
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Seed Sowing Date"
                        name="seedSowingDate"
                        type="date"
                        value={formData.seedSowingDate}
                        onChange={handleChange}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Cultivated Area"
                        name="cultivatedArea"
                        value={formData.cultivatedArea}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Crop Cutting Date"
                        name="cropCuttingDate"
                        type="date"
                        value={formData.cropCuttingDate}
                        onChange={handleChange}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Yield (5x5)"
                        name="yield5x5"
                        value={formData.yield5x5}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Production Amount"
                        name="productionAmount"
                        value={formData.productionAmount}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>

             

                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                paddingX: 3,
                                paddingY: 0.5,
                                height: "40px",
                                borderRadius: "20px",
                                backgroundColor: "#1976d2",
                                "&:hover": { backgroundColor: "#115293" },
                            }}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCancel}
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                paddingX: 3,
                                paddingY: 0.5,
                                height: "40px",
                                borderRadius: "20px",
                            }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/* <div>
                <h1>Add Crop Production</h1>
                <p>cropPlanMasterId: {cropPlanId || "ID not passed"}</p>
                <h3>Crop Plans</h3>
                <ul>
                    {cropPlanDetails.map((plan) => (
                        <li key={plan.cropPlanId}>Crop Plan ID: {plan.cropPlanId}</li>
                    ))}
                </ul>
            </div> */}
        </Paper>
    );
};

export default AddMarketLinkage;
